import { render, staticRenderFns } from "./BeneficiaryDetail.vue?vue&type=template&id=034e8302"
import script from "./BeneficiaryDetail.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetail.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryDetail.vue?vue&type=style&index=0&id=034e8302&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports